import { render } from "./EventList.vue?vue&type=template&id=2083cef1"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=2083cef1&lang=css"
script.render = render

export default script